import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// ── Global styles (design system + animations) ──────────────────────────
import './styles/global.css'
import './styles/animations.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
